const ALLOWED_KEYS = ["xs", "sm", "md", "lg", "xl"];
const isBreakpointsWithGuard = (value) => typeof value === "object" &&
  Object.keys(value).some((key) => ALLOWED_KEYS.includes(key));

export { isBreakpointsWithGuard as i };
